import { z } from 'zod'

// Outside systems a member has an identifier in (member.external_systems /
// member.user_external_ids -- see V640__external_systems.sql).

// Lowercase, URL- and code-safe; "members" is reserved by the routes.
export const SystemKeySchema = z
  .string()
  .trim()
  .toLowerCase()
  .regex(/^[a-z][a-z0-9_]{1,31}$/, 'Use 2-32 lowercase letters, digits or underscores, starting with a letter')
  .refine((v) => v !== 'members', { message: 'Reserved' })

export const CreateExternalSystemSchema = z.object({
  systemKey: SystemKeySchema,
  label: z.string().trim().min(1).max(60),
  description: z.string().trim().max(200).nullable().optional(),
  sortOrder: z.number().int().min(0).max(10000).optional(),
})
export type CreateExternalSystemInput = z.infer<typeof CreateExternalSystemSchema>

export const UpdateExternalSystemSchema = z
  .object({
    label: z.string().trim().min(1).max(60).optional(),
    description: z.string().trim().max(200).nullable().optional(),
    sortOrder: z.number().int().min(0).max(10000).optional(),
    archived: z.boolean().optional(),
  })
  .refine((v) => Object.keys(v).length > 0, { message: 'No fields to update' })
export type UpdateExternalSystemInput = z.infer<typeof UpdateExternalSystemSchema>

export const SetExternalIdSchema = z.object({ externalId: z.string().trim().min(1).max(200) })

export interface ExternalSystem {
  systemKey: string
  label: string
  description: string | null
  sortOrder: number
  archived: boolean
  // How many members hold an id in it; only returned to administrators.
  memberCount?: number
}

export interface MemberExternalId {
  systemKey: string
  externalId: string
}
